import { useState, useEffect, useRef } from 'react';
import { Phone, Calendar } from 'lucide-react';
import { Link } from 'react-router-dom';
import whatsapp from '../../assets/images/whatsapps.png';
import { ROUTES } from '../../routes/routePaths';

const ContactWhatsapp = () => {
    const whatsappNo = "919730032692";
    const whatsappLink = `https://wa.me/${whatsappNo}`;
    const callNumber = "+917276979336";

    const [isVisible, setIsVisible] = useState(false);
    const [isHovered, setIsHovered] = useState(false);
    const timerRef = useRef(null);
    const hideTimeoutRef = useRef(null);

    const isActive = isVisible || isHovered;

    const showPopupTemporarily = () => {
        if (!isHovered) {
            setIsVisible(true);
            clearTimeout(hideTimeoutRef.current);
            hideTimeoutRef.current = setTimeout(() => {
                if (!isHovered) {
                    setIsVisible(false);
                }
            }, 5000);
        }
    };

    useEffect(() => {
        timerRef.current = setInterval(() => {
            showPopupTemporarily();
        }, 15000);

        return () => {
            clearInterval(timerRef.current);
            clearTimeout(hideTimeoutRef.current);
        };
    }, []);

    const handleMouseEnter = () => {
        setIsHovered(true);
        setIsVisible(true);
        clearTimeout(hideTimeoutRef.current);
    };

    const handleMouseLeave = () => {
        setIsHovered(false);
        setIsVisible(false);
        clearTimeout(hideTimeoutRef.current);
    };

    return (
        <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-3">
            {/* Schedule to Book Demo Button */}
            <div className="relative flex items-center group">
                {/* Tooltip on hover */}
                <div className="mr-3 bg-white text-gray-800 text-sm font-medium px-4 py-2 rounded-2xl shadow-lg border border-gray-200 relative opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap">
                    Schedule a Demo
                    <div className="absolute -right-2 top-1/2 transform -translate-y-1/2 w-3 h-3 bg-white border-r border-t border-gray-200 rotate-45"></div>
                </div>

                <div className="w-14 flex justify-center">
                    <Link
                        to={ROUTES.REGISTER_FREE_SAMPLE || "/register-free-sample"}
                        className="w-10 h-10 bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white rounded-full shadow-lg flex items-center justify-center transition-all duration-300 group-hover:scale-125 active:scale-95 cursor-pointer"
                        aria-label="Schedule a Demo"
                        title="Schedule a Demo"
                    >
                        <Calendar className="w-5 h-5 text-white" />
                    </Link>
                </div>
            </div>

            {/* Call Button */}
            <div className="relative flex items-center group">
                {/* Tooltip on hover */}
                <div className="mr-3 bg-white text-gray-800 text-sm font-medium px-4 py-2 rounded-2xl shadow-lg border border-gray-200 relative opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap">
                    Call (+91) 7276979336
                    <div className="absolute -right-2 top-1/2 transform -translate-y-1/2 w-3 h-3 bg-white border-r border-t border-gray-200 rotate-45"></div>
                </div>

                <div className="w-14 flex justify-center">
                    <a
                        href={`tel:${callNumber}`}
                        className="w-10 h-10 bg-blue-600 hover:bg-blue-700 text-white rounded-full shadow-lg flex items-center justify-center transition-all duration-300 group-hover:scale-125 active:scale-95 cursor-pointer"
                        aria-label="Call (+91) 7276979336"
                        title="Call (+91) 7276979336"
                    >
                        <Phone className="w-5 h-5 text-white" />
                    </a>
                </div>
            </div>

            {/* WhatsApp Button */}
            <div
                className="flex items-center"
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
            >
                {/* Popup message */}
                <div
                    className={`
                        mr-3 bg-white text-gray-800 text-sm font-medium px-4 py-2 rounded-2xl shadow-lg border border-gray-200 relative
                        transition-all duration-300 transform origin-bottom-right
                        ${isVisible ? 'opacity-100 translate-y-0 scale-100' : 'opacity-0 translate-y-2 scale-95 pointer-events-none'}
                    `}
                >
                    Hey, I need some assistance?
                    <div className="absolute -right-2 top-1/2 transform -translate-y-1/2 w-3 h-3 bg-white border-r border-t border-gray-200 rotate-45"></div>
                </div>

                <a
                    href={whatsappLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block"
                    aria-label="Contact on WhatsApp"
                >
                    <img
                        src={whatsapp}
                        alt="whatsapp"
                        className={`
                            w-14 h-14 rounded-full shadow-lg transition-all duration-300 cursor-pointer
                            ${isActive ? 'scale-125 -translate-y-3' : 'scale-100 translate-y-0'}
                        `}
                    />
                </a>
            </div>
        </div>
    );
};

export default ContactWhatsapp;